module.exports = "<p-dropdown class=\"timerDropDown\" [options]=\"timeList\" [(ngModel)]=\"_selectedValue\" (onChange)=\"chageTime()\"></p-dropdown>"


//////////////////
// WEBPACK FOOTER
// /app/src/app/layout/time-dropdown/time-dropdown.component.html
// module id = ../../../../../src/app/layout/time-dropdown/time-dropdown.component.html
// module chunks = main